import { useState } from 'react'
import { musicEnabled, setMusicEnabled } from '../audio/music'
import { play, setSoundEnabled, soundEnabled } from '../audio/sfx'

/** ปุ่มคุมเสียง — แยกเอฟเฟกต์กับเพลงคลอออกจากกัน บางคนอยากได้แค่อย่างเดียว */
export function SoundToggle({ compact }: { compact?: boolean }) {
  const [sfxOn, setSfxOn] = useState(soundEnabled)
  const [musicOn, setMusicOn] = useState(musicEnabled)

  return (
    <span className="sound-toggle">
      <button
        className={`btn btn-ghost${compact ? ' btn-sm' : ''}`}
        aria-pressed={sfxOn}
        title={sfxOn ? 'ปิดเสียงเอฟเฟกต์' : 'เปิดเสียงเอฟเฟกต์'}
        onClick={() => {
          const next = !sfxOn
          setSoundEnabled(next)
          setSfxOn(next)
          if (next) play('tap')
        }}
      >
        {sfxOn ? '🔊' : '🔇'}
        {!compact && <span>เอฟเฟกต์</span>}
      </button>
      <button
        className={`btn btn-ghost${compact ? ' btn-sm' : ''}${musicOn ? '' : ' muted'}`}
        aria-pressed={musicOn}
        title={musicOn ? 'ปิดเพลงคลอ' : 'เปิดเพลงคลอ'}
        onClick={() => {
          const next = !musicOn
          setMusicEnabled(next)
          setMusicOn(next)
        }}
      >
        🎵
        {!compact && <span>เพลง</span>}
      </button>
    </span>
  )
}
